import React, {Component} from 'react';

import {Desktop, Mobile} from '../../responsive/index';
import FormCheckbox from '../FormCheckbox';
import GenderSelect from 'components/common/GenderSelect';
import CountrySelect from 'components/common/CountrySelect';
import RegionSelect from 'components/common/RegionSelect';
import {getFormData} from 'utils/forms';
import {getRegions, getCountries} from 'backend-helpers/misc';

import {t} from 'l10n';

import 'sass/common/MemberSearchForm.scss';

export default class MemberSearchForm extends Component {
    static defaultValues = {
        query: '',
        gender: '',
        age: '',
        country: '',
        region: '',
        exact: null,
        online: null,
        photo: null,
        certified_bobeur: null,
        certified_bobeuse: null
    };

    constructor(props) {
        super(props);

        let valuesMerged = {
            ...this.constructor.defaultValues,
            ...props.values
        };

        this.state = {
            ...valuesMerged,
            showmobile: false,
            countries: [],
            regions: []
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.handleFormInput = this.handleFormInput.bind(this);
        this.onCountrySelectChange = this.onCountrySelectChange.bind(this);
    }

    componentDidMount() {
        this.loadCountries();
        let countryCode = this.state.country;
        if (countryCode) {
            this.loadRegions(countryCode);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            ...this.constructor.defaultValues,
            ...nextProps.values
        });
    }

    toggleShowMobile() {
        let showStatus = this.state.showmobile;
        (showStatus) ? this.setState({showmobile: false}) : this.setState({showmobile: true});
    }

    handleFormInput(event) {
        let target = event.target;

        this.setState({
            [target.name]: target.value
        });
    }

    loadCountries() {
        getCountries().then((response) =>
            this.setState({countries: response.data})
        ).catch(

        );
    }
    loadRegions(countryCode) {
        getRegions(countryCode).then((response) =>
            this.setState({regions: response.data})
        ).catch(

        );
    }

    onCountrySelectChange(event) {
        this.handleFormInput(event);

        let countryCode = event.target.value;


        this.loadRegions(countryCode);
    }

    filterFormData(data) {
        data['query'] = data['query'].trim();
        if (data['query'].length < 3) data['query'] = '';

        return data;
    }

    onFormSubmit(event) {
        let {onSubmit} = this.props;

        event.preventDefault();

        if (onSubmit) {
            let inputSelector = this.state.showmobile ? ".mobile-show input, .mobile-show select, input[name=query]" : ".mobile-hide input, .mobile-hide select, input[name=query]";

            let formData = getFormData(event.target, {inputSelector, skipEmpty: true});

            onSubmit(formData);
        }
    }

    render() {
        let {showmobile, regions, countries} = this.state;

        let classShowMobile = "noActive";

        if (showmobile) {
            classShowMobile = "active";
        }

        return (
            <div className="form-search-member">

                <form onSubmit={this.onFormSubmit}>
                    <div className="space-between">
                        <div>
                            <input
                                name="query"
                                type="text"
                                placeholder={t('Member nick')}
                                value={this.state.query}
                                onChange={this.handleFormInput}
                            />
                        </div>
                        <Mobile>
                            <div className="toggle-show-mobile mobile-show">
                                <p onClick={(e) => {this.toggleShowMobile()}} className={classShowMobile + " text-show-mobile"}>
                                    <span>{t('Show advanced filters')}</span>
                                </p>
                                <div className={classShowMobile + " block-show-mobile"}>
                                    <div className="space-between selects mobile-show">
                                        <div className="gender">
                                            <p>{t('Gender:')}</p>
                                            <GenderSelect name="gender" value={this.state.gender} onChange={this.handleFormInput} showAllOption/>
                                        </div>
                                        <div className="age">
                                            <p>{t('Age!:')}</p>
                                            <select name="age" id="" value={this.state.age} onChange={this.handleFormInput}>
                                                <option value="">{t('Any')}</option>
                                                <option value="1">18-24</option>
                                                <option value="2">25-34</option>
                                                <option value="3">35-44</option>
                                                <option value="4">35-54</option>
                                                <option value="5">55-64</option>
                                                <option value="6">65-74</option>
                                                <option value="7">75+</option>
                                            </select>
                                        </div>
                                        <div className="country">
                                            <p>{t('Country:')}</p>
                                            <CountrySelect name="country" onChange={this.onCountrySelectChange} value={this.state.country} defaultValue={this.state.country} countries={countries}/>
                                        </div>
                                        <div className="region">
                                            <p>{t('Region:')}</p>
                                            <RegionSelect name="region" onChange={this.handleFormInput} value={this.state.region} defaultValue={this.state.region} regions={regions}/>
                                        </div>
                                    </div>
                                    <div className="mobile-show">
                                        <div className="check-box">
                                            <FormCheckbox field="exact" name={t('Exact match')} defaultChecked={this.state.exact ? 'checked' : ''}/>
                                        </div>

                                        <div className="check-box">
                                            <FormCheckbox field="online" name={t('Currently connected')}/>
                                        </div>

                                        <div className="check-box">
                                            <FormCheckbox field="photo" name={t('With photo')}/>
                                        </div>
                                    </div>
                                    <div className="mobile-show">
                                        <div className="check-box">
                                            <FormCheckbox field="certified_bobeur" name={t('Certified Bobeurs')}/>
                                        </div>
                                        <div className="check-box">
                                            <FormCheckbox field="certified_bobeuse" name={t('Certified Bobeuses')}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Mobile>
                        <div>
                            <button type="submit" className="btn-submit">{t('Search')}</button>
                        </div>
                    </div>
                    <Desktop>
                        <div className="space-between selects mobile-hide">
                            <div className="gender">
                                <p>{t('Gender:')}</p>
                                <GenderSelect
                                    name="gender"
                                    value={this.state.gender}
                                    onChange={this.handleFormInput}
                                    showAllOption
                                />
                            </div>
                            <div className="age">
                                <p>{t('Age:')}</p>
                                <select
                                    name="age"
                                    value={this.state.age}
                                    onChange={this.handleFormInput}
                                >
                                    <option value="">{t('Any')}</option>
                                    <option value="1">18-24</option>
                                    <option value="2">25-34</option>
                                    <option value="3">35-44</option>
                                    <option value="4">35-54</option>
                                    <option value="5">55-64</option>
                                    <option value="6">65-74</option>
                                    <option value="7">75+</option>
                                </select>
                            </div>
                            <div className="country">
                                <p>{t('Country:')}</p>
                                <CountrySelect
                                    name="country"
                                    onChange={this.onCountrySelectChange}
                                    defaultValue={this.state.country}
                                    countries={countries}
                                />
                            </div>
                            <div className="region">
                                <p>{t('Region:')}</p>
                                <RegionSelect name="region" onChange={this.handleFormInput} value={this.state.region} defaultValue={this.state.region} regions={regions}/>
                            </div>
                        </div>
                    </Desktop>
                    <Desktop>
                        <div className="mobile-hide">
                            <div className="check-box">
                                <FormCheckbox
                                    field="exact"
                                    name={t('Exact match')}
                                    defaultChecked={this.state.exact ? 'checked' : ''}
                                />
                            </div>

                            <div className="check-box">
                                <FormCheckbox
                                    field="online"
                                    name={t('Currently connected')}
                                    defaultChecked={this.state.online ? 'checked' : ''}
                                />
                            </div>

                            <div className="check-box">
                                <FormCheckbox
                                    field="photo"
                                    name={t('With photo')}
                                    defaultChecked={this.state.photo ? 'checked' : ''}
                                />
                            </div>
                        </div>
                    </Desktop>
                    <Desktop>
                        <div className="mobile-hide">
                            <div className="check-box">
                                <FormCheckbox
                                    field="certified_bobeur"
                                    name={t('Certified Bobeurs')}
                                    defaultChecked={this.state.certified_bobeur ? 'checked' : ''}
                                />
                            </div>
                            <div className="check-box">
                                <FormCheckbox
                                    field="certified_bobeuse"
                                    name={t('Certified Bobeuses')}
                                    defaultChecked={this.state.certified_bobeuse ? 'checked' : ''}
                                />
                            </div>
                        </div>
                    </Desktop>
                </form>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/MemberSearchForm.js